import { Box, Button, Stack } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo } from 'react';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface IUserDeleteConfirmDialogProps {
  userName: string;
  userEmail: string;
  handleConfirm: () => void;
}

function UserDeleteConfirmDialog({
  userName,
  userEmail,
  handleConfirm,
}: IUserDeleteConfirmDialogProps): JSX.Element {
  const dispatch = useAppDispatch();

  const handleCancel = () => {
    dispatch(closeDialog());
  };

  const handleDelete = () => {
    handleConfirm();
    dispatch(closeDialog());
  };

  return (
    <DialogContent width={{ desktop: 500 }} height={{ desktop: 'fit-content' }}>
      <DialogTitle hideCloseButton>참여자 삭제</DialogTitle>
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3, color: 'error.main' }}>
          경고: 참여자를 삭제하시겠습니까?
        </Box>
        <Box sx={{ fontSize: 16, mb: 2 }}>
          이름: <strong>{userName}</strong>
        </Box>
        <Box sx={{ fontSize: 16, mb: 3 }}>
          이메일: <strong>{userEmail}</strong>
        </Box>
        <Box sx={{ fontSize: 14, color: 'text.secondary', mb: 2 }}>
          ⚠️ 이 작업은 되돌릴 수 없습니다.
        </Box>
        <Box sx={{ fontSize: 14, color: 'text.secondary', mb: 2 }}>
          • 참여자의 모든 진단 데이터가 영구적으로 삭제됩니다.
        </Box>
        <Box sx={{ fontSize: 14, color: 'text.secondary', mb: 2 }}>
          • 진단 결과, 진행 상황, 완료 여부 등 모든 정보가 삭제됩니다.
        </Box>
        <Box sx={{ fontSize: 14, color: 'text.secondary' }}>
          • 삭제된 데이터는 복구할 수 없습니다.
        </Box>
      </DialogBody>
      <DialogButtons justifyContent="flex-end" marginTop="0px">
        <Stack direction="row" spacing={2} alignContent="center">
          <Button variant="outlined" color="inherit" onClick={handleCancel}>
            취소
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            삭제
          </Button>
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(UserDeleteConfirmDialog);


